
@if (bookingData != null) {
    <div class="container PGCustomerCareBooking">
        <div class="row">
            @for (field of ['user_name','user_email','user_phone']; track field) {
                @if (bookingData[field]) {
                    <div class="col-6 mb-3 form-group">
                        <div>
                            <label>
                                <b>{{ 'pg-customer-care-booking.field-' + field | locTranslate }}</b>
                            </label>
                            <div>
                                {{ bookingData[field] }}
                            </div>
                        </div>
                    </div>
                }
            }
        </div>
        <div class="row">
            <div class="col-6 mb-3 form-group">
                <div>
                    <label>
                        <b>{{ 'pg-customer-care-booking.field-date' | locTranslate }} - {{ 'pg-customer-care-booking.field-time' | locTranslate }}</b>
                    </label>
                    <div>
                        {{ bookingData.start_datetime + '+00:00' | locFormat:'date' }} - {{ bookingData.start_datetime + '+00:00' | locFormat:'time' }} - {{ bookingData.end_datetime + '+00:00' | locFormat:'time' }}
                    </div>
                </div>
            </div>
            <div class="col-6 mb-3 form-group">
                <div>
                    <label>
                        <b>{{ 'pg-customer-care-booking.field-status' | locTranslate }}</b>
                    </label>
                    <div>
                        <span class="badge bg-{{getStatusColor(bookingData.status)}}">
                            {{ 'pg-customer-care-booking.status-' + bookingData.status | locTranslate }}
                        </span>
                    </div>
                </div>
            </div>
            @if (bookingData.additional_info) {
                <div class="col-12 mb-3 form-group">
                    <div>
                        <label>
                            <b>{{ 'pg-customer-care-booking.field-additional_info' | locTranslate }}</b>
                        </label>
                        <div>
                            {{ bookingData.additional_info }}
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
}